/* @flow */
import React from 'react';

import Details from 'components/UIKit/Details';

import CloseDetailsLink from 'components/Links/CloseDetailsLink';
import CloseIcon from 'components/icons/CloseIcon';

export default function DetailsPanel(props: Object): React.Element {
  return (
    <Details
      CloseLink={CloseDetailsLink}
      CloseIcon={CloseIcon}
      {...props}
    >
      {props.children}
    </Details>
  );
}
